/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { passwordRegExp } from '../../constants/regExps';

export const validationSchema = Yup.object({
  email: Yup.string().trim().email('invalid_email').required('empty'),
  password: Yup.string().trim().required('empty').matches(passwordRegExp, 'invalid_password'),
  confirmPassword: Yup.string()
    .trim()
    .required('required')
    .oneOf([Yup.ref('password')], 'valid'),
  firstName: Yup.string().trim().required('empty'),
  lastName: Yup.string().trim().required('empty'),
});
